import { createFileRoute } from "@tanstack/react-router";
import { ConnectKubernetes } from "../../../features/infrastructure/cloud-kubernetes";

export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/kubernetes")({ component: Page });

function Page() {
  const { org } = Route.useParams();
  return <ConnectKubernetes org={org} />;
}
